<app-floorplan-menu-item-buttons>
  <button
    odxButton
    variant="ghost"
    class="air-path-button"
    (click)="addExhaustAirPath()"
    [odxTooltip]="tooltipTextAddExhaustAirPath"
    [odxTooltipOptions]="{ position: 'bottom' }"
    draggable="true"
    (dragstart)="dragExhaustAirPath()"
  >
    <odx-icon name="arrow-right" class="exhaust-air" size="medium"></odx-icon>
  </button>
  <button
    odxButton
    variant="ghost"
    class="air-path-button"
    (click)="addSupplyAirPath()"
    [odxTooltip]="tooltipTextAddSupplyAirPath"
    [odxTooltipOptions]="{ position: 'bottom' }"
    draggable="true"
    (dragstart)="dragSupplyAirPath()"
  >
    <odx-icon name="arrow-right" size="medium"></odx-icon>
  </button>
  <app-toggle-visibility-button
    [visible]="floorplanState.airPathsVisible"
    (toggleEvent)="floorplanState.airPathsVisible = $event"
  >
  </app-toggle-visibility-button>

  <app-toggle-item-text-visibility-button
    [itemTextVisible]="floorplanState.airPathsItemTextVisible"
    (toggleEvent)="updateAirPathsItemTextVisibility($event)"
  ></app-toggle-item-text-visibility-button>
  <app-toggle-lock-button [locked]="floorplanState.airPathsLocked" (toggleEvent)="floorplanState.airPathsLocked = $event">
  </app-toggle-lock-button>
</app-floorplan-menu-item-buttons>
